import { render } from "./appDown.vue?vue&type=template&id=d6a854de&scoped=true"
import script from "./appDown.vue?vue&type=script&lang=js"
export * from "./appDown.vue?vue&type=script&lang=js"

import "./appDown.vue?vue&type=style&index=0&id=d6a854de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a854de"]])

export default __exports__